// We re-export the functions of React Spring to always include the `cjs` bundle (for compability reasons with older browsers).

export { animated, config, useSpring } from 'react-spring/web.cjs';
